import React, { useEffect, useRef } from 'react';

interface AnimatedFeatureProps {
  text: string;
  delay: number;
}

const AnimatedFeature: React.FC<AnimatedFeatureProps> = ({ text, delay }) => {
  const elementRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate-feature-show');
          }
        });
      },
      {
        threshold: 0.1,
        rootMargin: '0px'
      }
    );

    if (elementRef.current) {
      observer.observe(elementRef.current);
    }

    return () => {
      if (elementRef.current) {
        observer.unobserve(elementRef.current);
      }
    };
  }, []);

  return (
    <div 
      ref={elementRef}
      className="p-8 border border-border hover:border-gray-600 transition-all transform hover:scale-[1.02] relative overflow-hidden group animate-feature-initial"
      style={{ transitionDelay: `${delay}ms` }}
    >
      <div className="absolute inset-0 bg-gradient-to-r from-transparent via-accent/5 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-1000 ease-in-out" />
      <h2 className="text-2xl md:text-3xl font-bold">
        {text}
      </h2>
    </div>
  );
}

export default AnimatedFeature;